const $ = global.$ || global.jQuery || require('jquery');

/**
 * Base component for visual components that represent a model that extends the
 * {@link SelectableItemModel}. This component displays the list of items from the model and
 * highlights the selected item, as well as handling user selections.
 */
const buildTemplate = (id) => {
  return `
      <select id="${id}" class="form-control mr-sm-2 hidden">
          <option></option>
      </select>
  `;
};

export default class SelectableItemSelectorComponent {

  /**
   * Constructor.
   *
   * @param componentId the unique identifier for the component within the DOM.
   * @param $parent JQuery object representing the parent element in which this component will be
   * inserted.
   * @param model the underlying model that extends {@link SelectableItemModel} for visual
   * representation by this component.
   * @param titleField the name of the field to use as the title for the item when rendering. See
   * @{link #_render()}. Default value is 'name'.
   */
  constructor(componentId, $parent, model, titleField = 'name') {

    // Capture references.
    this._componentId = componentId;
    this._model = model;
    this._titleField = titleField || 'name';

    // Insert the component into the parent.
    $(`#${this._componentId}`).remove();
    $parent.append(buildTemplate(this._componentId));
    this.$el = $(`#${this._componentId}`);

    // Handle events triggered by the user making a selection in the component.
    this.$el.change(this._handleUserSelection.bind(this));

    // Handle events in the underlying model.
    this._model.on(this._model.ON_LIST_CHANGE_EVENT, this._render.bind(this));
    this._model.on(this._model.ON_SELECTION_EVENT, this._highlightSelectedItem.bind(this));

    // Render the component.
    this._render();

  };

  /**
   * Private method to render the component.
   */
  _render() {

    // Clear the selector.
    this.$el.empty();

    // Re-populate with the list.
    this._model.getItems().forEach(function (_item) {
      this.$el.append(
        `<option value="${_item.id}">${_item[this._titleField]}</option>`
      );
    }, this);

    // Highlight the currently selected item.
    this._highlightSelectedItem();
  }

  /**
   * Private method to highlight the item that is selected in the model.
   */
  _highlightSelectedItem() {

    // De-select all entries.
    this.$el.find('option').removeProp('selected');

    // Select the current entry, if any.
    const selectedItem = this._model.getSelectedItem();
    if (selectedItem) {
      this.$el.find(`option[value="${selectedItem.id}"]`).prop('selected', true);
    }

  }

  /**
   * Handler invoked when the user makes a selection from the component.
   */
  _handleUserSelection(event) {
    const id = $(event.currentTarget).val();
    const selection = this._model.getItems().find(function(_item) {
      return _item.id == id;
    }.bind(this));
    this._model.setSelectedItem(selection);
  }

}



// WEBPACK FOOTER //
// ./src/app/map/components/selectable-item-selector.js